import { Box, IconButton, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { tokens } from '../theme';
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Link } from 'react-router-dom';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import TranslateIcon from '@mui/icons-material/Translate';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import 'react-pro-sidebar/dist/scss/styles.scss';
import { useContext } from 'react';
import { AdminContext } from '../context/AdminContext';
import { MessageRounded, Quiz } from '@mui/icons-material';

const Item = ({ title, to, icon, selected, setSelected, isCollapsed, setIsCollapsed }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <MenuItem active={selected === title} style={{ color: colors.redAccent[100] }} onClick={() => setSelected(title)} icon={icon}>
            <Typography>
                {title}
            </Typography>
            <Link to={to} onClick={() => { if (isCollapsed === false) { setIsCollapsed(true); } }} />
        </MenuItem>
    )
}

function Sidebar() {
    const { admin } = useContext(AdminContext);
    const theme = useTheme();
    const colors = tokens();
    const [isCollapsed, setIsCollapsed] = useState("false");
    const [selected, setSelected] = useState("Panel");

    useEffect(() => {
        const selectedTitle = window.location.pathname.split("/")[1];
        switch (selectedTitle) {
            case "users":
                setSelected("Kullanıcılar");
                break;
            case "bots":
                setSelected("Botlar");
                break;
            case "admins":
                setSelected("Yöneticiler");
                break;
            case "kanjis":
                setSelected("Kanjiler");
                break;
            case "faqs":
                setSelected("SSS");
                break;
            case "contactMessages":
                setSelected("İletişim Mesajları");
                break;
            default:
                setSelected("Kullanıcılar");

        }
    }, [])

    return (
        <Box position="fixed" height="100vh" zIndex="10" sx={{
            "& .pro-sidebar-inner": {
                background: `${colors.primary[400]} !important`
            },
            "& .pro-icon-wrapper": {
                backgroundColor: "transparent !important"
            },
            "& .pro-inner-item:hover": {
                color: "#868dfb !important"
            },
            "& .pro-menu-item.active": {
                color: "#6870fa !important"
            }
        }}>
            <ProSidebar collapsed={isCollapsed}>
                <Menu style={{ padding: "0px" }}>
                    <MenuItem onClick={() => { setIsCollapsed(!isCollapsed) }}
                        icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
                        style={{
                            color: colors.grey[100]
                        }}>
                        {!isCollapsed && (
                            <Box display="flex" justifyContent="space-between" alignItems="center" ml="15px">
                                <Typography variant="h3" color={colors.grey[100]}>
                                    JLPT
                                </Typography>
                                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                                    <MenuOutlinedIcon />
                                </IconButton>
                            </Box>
                        )}
                    </MenuItem>

                    <Box pl={isCollapsed ? undefined : "10%"}>
                        {admin.users_perm === 1 && <Item title="Kullanıcılar" to="/users" icon={<Groups2OutlinedIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
                        {admin.users_perm === 1 && <Item title="Botlar" to="/bots" icon={<FaceRetouchingNaturalIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
                        {admin.contents_perm === 1 && <Item title="Kanjiler" to="/kanjis" icon={<TranslateIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
                        {admin.faqs_perm === 1 && <Item title="SSS" to="/faqs" icon={<Quiz />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
                        {admin.contact_messages_perm === 1 && <Item title="İletişim Mesajları" to="/contactMessages" icon={<MessageRounded />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
                        {admin.admins_perm === 1 && <Item title="Yöneticiler" to="/admins" icon={<AdminPanelSettingsIcon />} selected={selected} setSelected={setSelected} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />}
                    </Box>
                </Menu>
            </ProSidebar>

        </Box>
    )
}

export default Sidebar